












































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Color,
  Flg,
  SumiFlg,
  OutStatus,
  JotaiKb,
  UmuFlg,
  ChohyoShurui,
} from '@/constants/constants';
import { downloadFile, getDefaultPagerInfo } from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { BUTTON } from '@/constants/label';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default Vue.extend<any, any, any, any>({
  name: 'G_030_JuchuToiawase_Table',
  components: {
    CtrlMessageDialog,
    CtrlNormalBtn,
    VuePdfEmbed,
  },
  props: {
    nyuryokuSumiFlg: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    Color,
    SumiFlg,
    Flg,
    JotaiKb,
    UmuFlg,
    ChohyoShurui,
    headers: [
      { text: '', value: 'data-table-select', width: 48 },
      {
        text: '発注日',
        value: 'hatchuYmd',
        sortable: true,
        width: 100,
      },
      {
        text: '発注№',
        value: 'hatchuNo',
        sortable: true,
        width: 85,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: 'ｵｰﾀﾞｰ№',
        value: 'orderNo',
        sortable: true,
        width: 95,
      },
      {
        text: '状態',
        value: 'jotaiKb',
        class: 'text-center',
        sortable: false,
        width: 60,
      },
      {
        text: '得意先',
        value: 'tokuisakiMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 340,
      },
      {
        text: '納品先',
        value: 'nohinsakiMei',
        sortable: true,
        width: 408,
      },
      {
        text: '品目（1件目）',
        value: 'himmokuMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 450,
      },
      {
        text: '納品希望日',
        value: 'nohinKiboYmd',
        sortable: true,
        width: 115,
      },
      {
        text: '納品予定日',
        value: 'nohinYoteiYmd',
        sortable: true,
        width: 115,
      },
      {
        text: '出荷日',
        value: 'shukkaYmd',
        sortable: true,
        width: 115,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '状態名',
        value: 'jotaiKbMei',
        sortable: true,
        width: 130,
      },
      { text: '', value: 'action', sortable: false, width: 325 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isClearTable: false,
    showPreviewPDF: [],
    BUTTON,
    Pdf: '',
    ID: '',
    isReload: false,
  }),

  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    tableHeight() {
      return this.$vuetify.breakpoint.height - 368;
    },
    localState: {
      get() {
        return this.selected;
      },
      set(value: any) {
        this.$emit('update:selected', value);
      },
    },
  },

  methods: {
    customSearch(_value: any, search: string | null, item: any) {
      const filterValues = [
        item['hatchuYmd'],
        item['hatchuNo'],
        item['orderNo'],
        item['tokuisakiMei'],
        item['nohinsakiMei'],
        item['himmokuMei'],
        item['nohinKiboYmd'],
        item['nohinYoteiYmd'],
        item['jotaiKbMei'],
      ];

      return filterValues.some(
        (v: any) =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search ? search.toLowerCase() : '')
      );
    },

    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      if (this.isClearTable) {
        this.isClearTable = false;
        this.$emit('clear-table');
      }
      if (this.isReload) {
        this.isReload = false;
        this.$emit('reload');
      }
    },

    handleOpenFile(item: any) {
      this.Pdf = item.tempShiryo;
      this.ID = item.id;
      this.showPreviewPDF = true;
    },

    async clickDownload(item: any, chohyoShurui: number) {

      let result;

      switch (chohyoShurui){

        case ChohyoShurui.SHUKKA_ANNAISHO:
          result = await this.handleDownloadFiles(item.shukkaAnnaiUrl, chohyoShurui);
          if (result === true) {
            item.shukkaAnnaiDlFlg = SumiFlg.SUMI;
          }
          break;
      
        case ChohyoShurui.NOHINSHO:
          result = await this.handleDownloadFiles(item.nohinshoUrl, chohyoShurui);
          if (result === true) {
            item.nohinshoDlFlg = SumiFlg.SUMI;
          }
          break;
          
        case ChohyoShurui.JUCHU_UKESHO:
          result = await this.handleDownloadFiles(item, chohyoShurui);
          if (result === true) {
            item.juchuUkeshoDlFlg = SumiFlg.SUMI;
          }
          break;
      }
    },

    async handleDownloadFiles(s3Url: any, chohyoShurui: number) {
      try {
        let params, result;

          // ダウンロード更新
          switch (chohyoShurui){
            
            case ChohyoShurui.SHUKKA_ANNAISHO:

              for(let i=0; i<s3Url.length; i++) {
                // ダウンロード
                await this.handleDownloadFile(s3Url[i].url);
                params = {
                  shukkaJigyoshoCd: s3Url[i].shukkaJigyoshoCd,
                  shukkaEntryYmd: s3Url[i].shukkaEntryYmd,
                  shukkaNo: s3Url[i].shukkaNo,
                };
                result = await this.$store.dispatch('g030/putShukkaAnnai', params);
                
                if (
                  result &&
                  result.status == 200 &&
                  result.data &&
                  result.data.error &&
                  result.data.error.outStatus &&
                  result.data.error.outStatus != OutStatus.NORMAL
                ) {
                  this.messageId = result.data.error.messageID;
                  this.messageTextParam = result.data.error.messageArgs;
                  this.messageShow = true;
                  return false;
                }
              }
              break;
      
            case ChohyoShurui.NOHINSHO:

              for(let i=0; i<s3Url.length; i++) {
                // ダウンロード
                await this.handleDownloadFile(s3Url[i].url);
                params = {
                  uriageEntryJigyoshoCd: s3Url[i].uriageEntryJigyoshoCd,
                  uriageEntryYmd: s3Url[i].uriageEntryYmd,
                  uriageNo: s3Url[i].uriageNo,
                  uriageShuseiCount: s3Url[i].uriageShuseiCount,
                };
                result = await this.$store.dispatch('g030/putNohinsho', params);
                
                if (
                  result &&
                  result.status == 200 &&
                  result.data &&
                  result.data.error &&
                  result.data.error.outStatus &&
                  result.data.error.outStatus != OutStatus.NORMAL
                ) {
                  this.messageId = result.data.error.messageID;
                  this.messageTextParam = result.data.error.messageArgs;
                  this.messageShow = true;
                  return false;
                }
              }
              break;
              
            case ChohyoShurui.JUCHU_UKESHO:

              // ダウンロード
              await this.handleDownloadFile(s3Url.juchuUkeshoUrl);

              params = {
                juchuEntryJigyoshoCd: s3Url.juchuEntryJigyoshoCd,
                juchuEntryYmd: s3Url.juchuEntryYmd,
                juchuNo: s3Url.juchuNo,
                juchuShuseiCount: s3Url.juchuShuseiCount,
              };

              result = await this.$store.dispatch('g030/putJuchuUke', params);

              if (
                result &&
                result.status == 200 &&
                result.data &&
                result.data.error &&
                result.data.error.outStatus &&
                result.data.error.outStatus != OutStatus.NORMAL
              ) {
                this.messageId = result.data.error.messageID;
                this.messageTextParam = result.data.error.messageArgs;
                this.messageShow = true;
                return false;
              }

              break;

          }
        
        return true;
      } catch (error) {
        return false;        
      }
    },

    async handleDownloadFile(s3Url: any) {
      let dataUri = '';
      const response = await this.$store.dispatch('common/gDownloadFile', {
        s3Url,
      });
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.error &&
        response.data.error.outStatus &&
        response.data.error.outStatus != OutStatus.NORMAL
      ) {
        if (response.data.error.messageID == 'KI_W107') {
          this.messageId = 'KI_W124';
          this.isReload = true;
        } else {
          this.messageId = response.data.error.messageID;
        }
        this.messageTextParam = response.data.error.messageArgs;
        this.messageShow = true;
        return;
      } else {
        dataUri = response.data.responseData.dataUri;
        const fileName = decodeURI(s3Url).split('/');
        downloadFile(dataUri, fileName[fileName.length - 1]);
      }
    },

    // PDF出力
    handlePdfOut(item : any) {
      const linkSource = item.tempShiryo;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = item.tempFileName;
      downloadLink.click();
    },

    //別紙添付データ取得
    getAttachedData(item: any) {
      this.$store.dispatch('common/setIsLoading', true);
      if (item.tempShiryo) {
        this.$set(this.showPreviewPDF, item.id, true);
        this.$store.dispatch('common/setIsLoading', false);
      } else {
        const params = {
          tempEntryYmd: item.tempEntryYmd,
          tempSeq: item.tempSeq,
          tempMukoFlg: item.tempMukoFlg
        };

        this.$store.dispatch(
          'common/getBesshiTemp',
          params
        ).then((res: any) => {
          if (
            res &&
            res.status == 200 &&
            res.data &&
            res.data.error &&
            res.data.error.outStatus &&
            res.data.error.outStatus != OutStatus.NORMAL
          ) {
            const { error } = res.data;
            this.messageShow = true;
            this.messageId = error.messageID;
            this.messageTextParam = error.messageArgs;
            this.isReload = true;
            this.$store.dispatch('common/setIsLoading', false);
            return;
          }
          if (!res.data.responseData) {
            this.messageShow = true;
            this.messageId = 'KI_W124';
            this.messageTextParam = [];
            this.isReload = true;
            this.$store.dispatch('common/setIsLoading', false);
            return;
          }
          item.tempShiryo = res.data.responseData.tempShiryo;
          this.$set(this.showPreviewPDF, item.id, true);
          this.$store.dispatch('common/setIsLoading', false);
        });
      }
    },
  },

  mounted() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
